import { useNavigate } from 'react-router-dom'
import { API_URL } from '../constants'

export function useDeleteItem() {
    const navigate = useNavigate()

    return async function ({ url, token, navigateSuccess, onError }) {
        return deleteItem({
            url,
            token,
            navigate,
            navigateSuccess,
            onError,
        })
    }
}
async function deleteItem({
    url,
    token = localStorage.getItem('token'),
    navigate,
    navigateSuccess = '/admin/auth',
    onError,
}) {
    try {
        const res = await fetch(`${API_URL}/${url}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept-Language': 'en',
            },
        })

        if (res.ok) {
            navigate(navigateSuccess)
        } else {
            const json = await res.json()
            onError?.(json.message || 'Failed to delete')
        }
    } catch (error) {
        console.error(error)
        onError?.(error.message || 'Something went wrong')
    }
}
